import { useEffect, useState } from 'react';

const readDocumentVisible = (): boolean =>
  typeof document === 'undefined' || document.visibilityState === 'visible';

/** True while the page tab is visible (Page Visibility API). */
export const useDocumentVisible = (): boolean => {
  const [visible, setVisible] = useState(readDocumentVisible);

  useEffect(() => {
    const sync = () => {
      setVisible(document.visibilityState === 'visible');
    };

    document.addEventListener('visibilitychange', sync);
    return () => document.removeEventListener('visibilitychange', sync);
  }, []);

  return visible;
};
